import React, { useState, useEffect } from "react";
import { Tabs, Grid, Typography, Spin } from "antd";
import {
  ProfileOutlined,
  LineChartOutlined,
  HistoryOutlined,
} from "@ant-design/icons";
import { getRequest } from "services/EndPointApiService";
import CustomerProfileSection from "./CustomerProfileSection";
import CustomerOrderCards from "./CustomerKeepan";
import CustomerHistorySection from "./CustomerHistorySection";
import OrderCardList from "./CurrentOrder";

const { Title } = Typography;

const sectionTitleStyle = {
  color: "#fff",
  marginBottom: 12,
  fontSize: 18,
  fontWeight: 600,
};

const { useBreakpoint } = Grid;

const Customer360Dashboard = () => {
  const screens = useBreakpoint();

  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("profile");

  const [customer360, setCustomer360] = useState({});

  // Simulasi terima event appContext dari Chatwoot
  useEffect(() => {
    setLoading(true);

    window.parent.postMessage("chatwoot-dashboard-app:fetch-info", "*");
    const handleEvent = function (event) {
      try {
        var data = JSON.parse(event.data);
        if (data.event === "appContext") {
          var phone = data.data.contact.phone_number;
          if (phone) {
            getRequest(
              `DataList/GetCustomer360/${phone}/pPqZBsXN3Fw3hGkPgE9ZC7MX9eeKVkJC9a`
            ).then((res) => {
              setCustomer360({
                customers: res.customer || [],
                keepan: res.keepan || [],
                histories: res.history || [],
                pesanan: res.pesanan || [],
              });
              setLoading(false);
            });
          }
        }
      } catch (e) {
        console.log("Non-JSON or irrelevant message:", event.data);
      }
    };

    window.addEventListener("message", handleEvent);

    return () => {
      window.removeEventListener("message", handleEvent);
    };

    // Untuk testing sementara, pakai nomor sendiri
    // var phone = "6282180238949";
    // if (phone) {
    //   getRequest(
    //     `DataList/GetCustomer360/${phone}/pPqZBsXN3Fw3hGkPgE9ZC7MX9eeKVkJC9a`
    //   ).then((res) => {
    //     console.log("res customer360", JSON.stringify(res.pesanan[0]));
    //     setCustomer360({
    //       customers: res.customer || [],
    //       keepan: res.keepan || [],
    //       histories: res.history || [],
    //       pesanan: res.pesanan || [],
    //     });
    //     setLoading(false);
    //   });
    // }
  }, []);

  if (loading) {
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          background: "#141414",
        }}
      >
        <Spin size="large" tip="Menunggu data dari chatwoot..." />
      </div>
    );
  }

  return (
    <div
      style={{
        minHeight: "100vh",
        padding: 16,
        paddingBottom: screens.xs ? 70 : 16,
        background: "linear-gradient(135deg, #141414 0%, #1f1f1f 100%)",
      }}
    >
      {/* Profile Section */}
      {(activeTab === "profile" || !screens.xs) && (
        <div style={{ marginBottom: 16 }}>
          <Title level={4} style={sectionTitleStyle}>
            👤 Data Customer
          </Title>
          <CustomerProfileSection customers={customer360.customers} />
          <Title level={4} style={sectionTitleStyle}>
            🛒 Pesanan Saat Ini
          </Title>
          <OrderCardList orders={customer360.pesanan} />
        </div>
      )}

      {/* Metrics Section */}
      {(activeTab === "keepan" || !screens.xs) && (
        <div style={{ marginBottom: 16 }}>
          <Title level={4} style={sectionTitleStyle}>
            📦 Keepan Customer
          </Title>
          <CustomerOrderCards
            orders={customer360.keepan.filter((k) => !k.SendFlag)}
          />
        </div>
      )}

      {/* Timeline Section */}
      {(activeTab === "history" || !screens.xs) && (
        <div style={{ marginBottom: 16 }}>
          <Title level={4} style={sectionTitleStyle}>
            🕑 Riwayat Pesanan
          </Title>
          <CustomerHistorySection history={customer360.histories} />
        </div>
      )}

      {/* Bottom Navigation hanya di layar kecil */}
      {screens.xs && (
        <div
          style={{
            position: "fixed",
            bottom: 0,
            left: 0,
            right: 0,
            background: "#1f1f1f",
            borderTop: "1px solid #333",
            padding: "6px 0",
          }}
        >
          <Tabs
            activeKey={activeTab}
            onChange={setActiveTab}
            centered
            tabBarStyle={{ margin: 0, color: "#fff" }}
            items={[
              {
                key: "profile",
                label: (
                  <div style={{ textAlign: "center", color: "#fff" }}>
                    <ProfileOutlined />
                    <div style={{ fontSize: 12 }}>Profile</div>
                  </div>
                ),
              },
              {
                key: "keepan",
                label: (
                  <div style={{ textAlign: "center", color: "#fff" }}>
                    <LineChartOutlined />
                    <div style={{ fontSize: 12 }}>Keepan</div>
                  </div>
                ),
              },
              {
                key: "history",
                label: (
                  <div style={{ textAlign: "center", color: "#fff" }}>
                    <HistoryOutlined />
                    <div style={{ fontSize: 12 }}>History</div>
                  </div>
                ),
              },
            ]}
          />
        </div>
      )}
    </div>
  );
};

export default Customer360Dashboard;
